import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export interface ComponentCanDeactivate {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component) => {
  const translate = inject(TranslateService);

  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const message = translate.instant('PACKAGES_PERSO_MANAGEMENT.UNSAVED_CHANGES_CONFIRM');

  return window.confirm(message);
};
